import React from "react";
import styled from "styled-components";
import {CheckmarkCircleMIcon} from '@alfalab/icons-glyph';
import {Typography} from '@alfalab/core-components/typography';
import {MyFormValues} from "../../Form/Form";

const Container = styled.div`
    width: 900px;
    padding: 40px 30px 40px;
    box-shadow: 0 0 5px 0 rgba(0,0,0,.2);
    box-sizing: border-box;
    margin: 40px auto 20px;
    background: #fff;
    border-radius: 3.01px;
    display: flex;
    flex-direction: row;
    align-items: flex-start; 
    
    @media screen and (max-width: 699px){
        width: 100%;
        border-radius: 0;
        padding: 20px 30px 20px;
    }    
`;
const SizedIcon = styled(CheckmarkCircleMIcon)`
     height: 88px !important;
     width: 200px !important;
     margin-right: 20px;
`;
type Props = {
    data: MyFormValues
}

const Success: React.FC<Props> = (props: Props) => {
    return (
        <Container>
            <SizedIcon/>
            <Typography.Text><b>{props.data.counterpart.fio}</b>, благодарим за заинтересованность в сотрудничестве с ЗАО «Альфа-Банк»! <br/>
                В качестве конкурсного предложения <b>{props.data.counterpart.name}</b> направлен пакет документов. <br/>
                <br/>
                <b style={{textDecoration: "underline"}}>В качестве подтверждения</b> получения предложения после автоматической обработки, в течение нескольких минут, Вам на почтовый
                ящик <b>{props.data.counterpart.email}</b> будет направлен итоговый список полученных Банком документов.
                Проверьте его, пожалуйста, на корректность и
                полноту. Если по какой-либо причине Вами был направлен не полный комплект документов, составляющих конкурсное предложение, то отправка дополнительных файлов осуществляется таким же образом (без направления ранее отправленных документов) - ссылка на форму отправки дополнительных файлов приведена в сообщении, направленном по указанному выше адресу электронной почты.
                <br/> <br/>
                <b style={{color: "red"}}>Eсли ответа с перечнем документов нет - предложение не было получено банком. <br/>Свяжитесь с Секретарем Комитета по закупкам. </b>
                <br/> <br/>
                В случае возникновения вопросов просим обращаться к сотрудникам Банка, указанным в документации по закупке в качестве ответственных по вопросам проведения процедуры закупки.
            </Typography.Text>
        </Container>
    )

};

export default Success;